define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "註冊其他用戶",

    'incrowd_stats.num_responders': "{{num}}位醫療專業專家",
    'incrowd_stats.num_answers': "回答了{{num}}個問題",
    'incrowd_stats.time_to_complete': "{{num}}分鐘來完成一般問卷",

    // INCROWD
    'incrowd.about': "關於",
    'incrowd.contact': "連絡",
    'incrowd.press': "發布",
    'incrowd.careers': "職業",
    'incrowd.terms': "條款",
    'incrowd.t_and_c': "條款與條件",
    'incrowd.faq': "常見問題",
    'incrowd.privacy': "隱私",
    'incrowd.copyright': "{{year}}年，InCrowd公司版權所有",
    'incrowd.blog': "部落格",
    'incrowd.support': "支援",
    'incrowd.info.ios': "您知道嗎，現在InCrowd網絡上的醫師可以直接向他們的同事發送問題？立刻試試<InCrowd iOS應用>!",
    'incrowd.refer': "喜歡我們的調查？立刻<推薦一位好友>加入我們的圈子，你們兩個都可以獲得10美金（或等價物）。你的同事回答完一個調查後，他們或立刻收到獎勵！",

    // GET STARTED (step 0)
    'getstarted.encourage.title': "調查雖小，",
    'getstarted.encourage.title.two': "影響甚大",
    'getstarted.encourage.subtitle': "成為上千認證醫療專業人士中的一員，通過簡單的小調查影響新藥品的開發與患者的治療，您還會獲得獎勵！",
    'getstarted.encourage.redirect_to_solutions': "並非醫療護理專業人員，但想更詳細地瞭解有關 InCrowd 的事情嗎？",
    'getstarted.actions.title': "您是一名合格的醫療專業人士嗎？",
    'getstarted.actions.subtitle': "立刻註冊，回答醫療小調查，開始賺錢",
    'getstarted.button.continue': "開始",
    'getstarted.referral': "註冊並獲得問卷調查獎金，以及你的%{{referrerName}}推薦獎金。",
    'getstarted.complete_registration': " Complete your InCrowd registration and start receiving surveys today!",
    'getstarted.questions': "Have questions? Use the chat box on the bottom right of the screen, we're here to help.",

    'details.need_info_description': "我們需要您的一些資料來設定您的帳號。",
    'details.profile_details': "個人資料",
    'details.address_information': "地址資訊",
    'details.professional_info': "職業資訊",
    'details.heading.finally': "最後",
    'details.how_receive_surveys': "您想要如何接收調查？",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "基礎問題",
    'professionchoice.encourage.subtitle': "沒有看到您的職業？在<這裡>告訴我們，當添加了您的職業後，我們會通知您。",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "您是誰？",
    'authentication.encourage.subtitle': "InCrowd需要驗證您的身份，但我們不會向第三方披露或傳發您的個人資訊。",
    'authentication.actions.select_notifications': "選擇您想以何種方式接受我們的調查",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "我們正在驗證您的資訊，請稍等",
    'validation.please_answer': "請回答以下問題以幫助我們驗證您的個人詳細資訊",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "確認",
    'confirmation.validation_success.subtitle': "您已完成登記，歡迎來到 InCrowd! 您將立刻透過電子郵件或簡訊收到確認訊息。感謝您的加入!",
    'confirmation.validation_error.title': "需要額外的資訊",
    'confirmation.validation_error.subtitle': "很抱歉%{userFirstName}，驗證您的個人詳細資訊時發現了一個問題。",
    'confirmation.actions_title': "下一步呢？",
    'confirmation.go_to_your_profile': "前往您的個人檔案",
    'confirmation.validation_success.actions_subtitle': "您在幾天後會經由電子郵件或簡訊收到我們所發的三到五分鐘小型調查。不想經由簡訊收到調查嗎? 您可以隨時從您InCrowd的個人簡介中更改您的通訊設定。",
    'confirmation.validation_error.actions_subtitle': "請利用螢幕右下方的跳出聊天來和InCrowd團隊成員交談，並且提出任何超讚的問題。",
    'confirmation.referral.info.1': "完成第二項調查後，你和你的推薦人將於%{payoutBusinessDays}個工作天內<收到%{currency}%{referralBonusAmount}>。%{currency}%{referralBonusAmount}會匯入你的獎金帳號。你可以隨時登入你的<個人資料檔>，以更新偏好設定、查看獎金，或進行任何已受邀的公開問卷調查。",
    'confirmation.referral.info.2': "有任何問題？<與我們聯絡>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "您符合要求嗎？",
    'regftr.markets.accepting': "InCrowd回答目前正接收：",
    'regftr.peers.title': "同行人士",
    'regftr.peers.subtitle': "將您的答案與同行人士對比，學習他們的回答。 ",
    'regftr.invites.title': "邀請",
    'regftr.invites.subtitle': "通過郵件或電話接收新的調查邀請，讓收益最大化。 ",
    'regftr.earnings.title': "收入",
    'regftr.earnings.subtitle': "管理並追蹤您的收入與支付資訊。",
    'regftr.stats.title': "統計",
    'regftr.stats.subtitle': "使用您全部的調查資訊與用戶數據訪問控制頁。",

    'contextual_help.sms': "你將收到有關公開小型問卷調查的簡訊通知，透過簡訊你將比較快進入問卷調查並獲取更多獎金，你的資料會隱密的保存並只針對問卷調查邀請做使用。",
    'contextual_help.specialty': "請只要包含連結到您的新產品介紹專長就好，您已完成了獎學金的申請或者列入您主要專長的醫學領域。假如您未來需要變更您的專長，請用電子郵件聯絡support@incrowdnow.com。",
    // USER
    'user(s)': "用戶 |||| 用戶",
    'user.login': "登入",
    'user.logout': "登出",
    'user.register': "註冊",
    'user.invitations': "邀請",
    'user.email': "電郵",
    'user.pass_word': "密碼",
    'user.mobile': "手機號碼",
    'user.mobile.hint': "請加上國家代碼 (為+%{phoneCode} 加上 %{countryName})",
    'user.title': "稱呼",
    'user.title_with_example': "稱呼（如博士，女士，先生。）",
    'user.first_name': "名稱",
    'user.last_name': "姓氏",
    'user.middle_name': "中間名",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}。",
    'user.anonymous': "用戶",
    'user.anonymous_admin': "管理員",
    'user.dashboard': "控制頁",
    'user.profile': "個人資料",
    'user.profile.picture.upload': "上載個人照片",
    'user.profile.picture.change': "變更",
    'user.primary_lang': "主要語言",
    'user.primary_lang?': "您主要使用哪種語言？",
    'user.survey_langs?': "您可以流利使用哪些語言？",
    'user.notify_email': "用郵件通知",
    'user.notify_mobile': "用手機通知",
    'user.contact_support': "連絡客戶支援",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "請<連絡我們>。",
    'user.profession': "職業",
    'user.profession?': "您的職業是什麼？",
    'user.join_now': "立刻加入",
    'user.welcome_back': "歡迎回來！",
    'user.not_a_member?': "還不是會員？",
    'user.accept_terms': "接受條款",
    'user.accept_terms.yes': "我接受<條款與條件>",
    'user.remember_me': "在此裝置上記得我",
    'user.time_zone': "時區",
    'user.payment.policy': "每次達到%{currency}時，您將獲得價值25元的免費禮物作為報酬時，您將會被通知並且透過您InCrowd的個人簡介中，您能夠從我們的付款選項中去選擇您所想要的付款方式。還有疑問嗎? 可透過下方的對話視窗聯絡我們。",
    'user.country.live_work?': "您生活和工作在哪個國家？",
    // FORMS
    'form.button.back': "返回",
    'form.button.next': "前進",
    'form.button.cancel': "取消",
    'form.button.submit': "提交",
    'form.button.continue': "繼續",
    'form.button.close': "關閉",
    'form.button.go!': "前往！",
    'form.button.complete!': "立刻完成！",
    'form.button.update': "更新",
    'form.button.finish': "完成",
    'form.button.search': "搜尋",
    'form.button.end': "結束",
    'form.search.no_matches': "未找到匹配項",
    'form.confirm_email': "確認郵件",
    'form.confirm_pass_word': "確認密碼",
    'form.required_fields': "必填項",
    'form.nothing_selected': "未選中任何內容",
    'form.confirm_field': "確認 %{formFieldLabel}",
    'form.choice.n/a': "不適用",
    'form.choice.yes': "是",
    'form.choice.no': "否",
    'form.choice.blank_for_all': "留白以全部選中",
    'form.choices.select_all': "全選",
    'form.choices.deselect_all': "取消全選",
    'form.field.private': "隱私項",

    // USER ERRORS
    'user.error.dup_email': "另一位用戶已經用收到的電子郵件地址註冊了。<要登入嗎？>",
    'user.error.dup_sms': "其他用戶已經使用此手機號碼註冊了",
  }
})
